import React, { useEffect } from 'react';

import { Select, Tooltip } from '@gogame/components';
import { useMountedState, useProcessAsync } from '@gogame/hooks-ts';
import {
  useScreenDispatch,
  useScreenMessage,
  useScreenState,
} from '@gogame/screens';

import { PARTNERS } from 'scenes/BulkUpload/constants';
import { getPartners } from 'scenes/BulkUpload/sources/bulk-uploader';

import { SET_PARTNER } from '../../screenReducer';

export default () => {
  const [data, setData] = useMountedState([]);
  const [loading, loadingWrapper] = useProcessAsync();

  const dispatch = useScreenDispatch();
  const screenState = useScreenState();
  const { showErrorMessage } = useScreenMessage();

  const loadData = async () => {
    const data = await loadingWrapper(getPartners());
    setData(data);
  };
  useEffect(() => {
    loadData();
  }, []);

  useEffect(() => {
    if (!data.length) return;

    const isValidPartner = data
      .map(({ id }) => id)
      .includes(screenState.partner);

    if (!isValidPartner) {
      showErrorMessage(`Partner "${screenState.partner}" not supported`);
      dispatch({
        type: SET_PARTNER,
        payload: data[0].id,
      });
    }
  }, [data, screenState.partner]);

  const handleChange = (_e, value) => {
    dispatch({
      type: SET_PARTNER,
      payload: value,
    });
  };

  return (
    <Tooltip title={'Partners'} wrapper>
      <Select
        withFilter={false}
        value={screenState.partner}
        name={PARTNERS}
        loading={loading}
        disabled={data.length === 1}
        options={data}
        onChange={handleChange}
      />
    </Tooltip>
  );
};
